import Analysis from "../components/Analysis"

/**
 * Component for radiographic image analysis
 * This is a wrapper around the unified Analysis component
 *
 * @returns {JSX.Element} AnalisisRadiograph component
 */
const AnalisisRadiograph = () => {
  return <Analysis analysisType="radiograph" />
}

export default AnalisisRadiograph
